import { useEffect, useState } from "react";
import { Camera } from "lucide-react";
import { api } from "@/lib/api";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

export const DoorSnapshot = ({ id, label, testid }) => {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let url;
    api.get(`/admin/door-snapshots/${id}`, { responseType: "blob" })
      .then((r) => { url = URL.createObjectURL(r.data); setSrc(url); })
      .catch(() => setFailed(true));
    return () => url && URL.revokeObjectURL(url);
  }, [id]);
  if (failed) return <Camera size={14} className="text-white/20" title="Photo unavailable" />;
  if (!src) return <span className="h-9 w-12 rounded bg-white/5 animate-pulse shrink-0" />;
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid={testid} className="shrink-0 rounded overflow-hidden border border-white/10 hover:border-[#D4AF37]">
        <img src={src} alt="Door camera snapshot" className="h-9 w-12 object-cover" />
      </button>
      {open && createPortal(
        <div data-lightbox className="fixed inset-0 z-[100] bg-black/85 flex items-center justify-center p-4" onClick={() => setOpen(false)} data-testid={`${testid}-dialog`}>
          <div className="bg-[#111] border border-white/10 rounded-2xl p-4 max-w-2xl w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-3">
              <p className="text-white text-sm">{label}</p>
              <button onClick={() => setOpen(false)} data-testid={`${testid}-close`} className="text-white/50 hover:text-white"><X size={16} /></button>
            </div>
            <img src={src} alt="Door camera snapshot" className="w-full rounded-lg" data-testid={`${testid}-full`} />
          </div>
        </div>, document.body)}
    </>
  );
};
